// Some historical translated arrays are stored as serialized JSON strings.
// Decode primitive string lists in any namespace, preserving existing behaviour.
// A special, strictly shaped decoder covers patient-role FAQ arrays of objects.
// Do not decode arbitrary JSON objects/arrays or Terms sections; this would
// bypass legal source-revision checks and alter unrelated language resources.
const isFaqPath = path => path.length === 3
  && path[0] === 'items' && path[2] === 'faqs';

const validFaqArray = value => Array.isArray(value)
  && value.length > 0 && value.length <= 40
  && value.every(item => item && typeof item === 'object' && !Array.isArray(item)
    && Object.keys(item).length === 2
    && Object.keys(item).every(key => key === 'question' || key === 'answer')
    && typeof item.question === 'string' && item.question.trim()
    && typeof item.answer === 'string' && item.answer.trim());

export function normalizeLocaleResourceData(value, path = []) {
  if (Array.isArray(value)) return value.map((item, index) =>
    normalizeLocaleResourceData(item, [...path, String(index)]));
  if (value && typeof value === 'object')
    return Object.fromEntries(Object.entries(value).map(([key, child]) =>
      [key, normalizeLocaleResourceData(child, [...path, key])]));
  if (typeof value !== 'string') return value;
  const raw = value.trim();
  if (!/^\[\s*["{]/.test(raw)) return value;
  try {
    const decoded = JSON.parse(raw);
    if (Array.isArray(decoded) && decoded.length
      && decoded.every(item => typeof item === 'string')) return decoded;
    if (isFaqPath(path) && validFaqArray(decoded)) return decoded;
  } catch { /* Retain the original source when serialized JSON is invalid. */ }
  return value;
}
